import { TXProductDetailsTemplate } from "../../../types/common/templates.types";

export const X_PRODUCT_DETAILS_TEMPLATE2: TXProductDetailsTemplate = {
  "Template avec Liste": {
    image:
      "https://firebasestorage.googleapis.com/v0/b/xoraia-prod.appspot.com/o/previews%2Fcontainers%2FXProductDetails%2FCapture%20d%E2%80%99e%CC%81cran%202022-11-19%20a%CC%80%2014.46.04.png?alt=media&token=6567f799-f303-4d3e-91e1-a46728b23072",
    template: [
      {
        name: "XProductDetails",
        props: {
          all: {
            previewMode: "list",
            padding: { Top: "20px", Bottom: "20px" },
          },
        },
      },
    ],
  },
};
